import React from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';

const StyledTestimonials = styled.div`
	section {
		text-align: center;
		h2 {
			margin-bottom: 2rem;
		}
		.logos {
			display: flex;
			.img-wrap {
				padding: 0 0.5rem;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			@media all and (max-width: 768px) {
				flex-wrap: wrap;
				justify-content: center;
				.img-wrap {
					width: 50%;
				}
			}
		}
	}
`;

export default () => {
	return (
		<StyledTestimonials>
			<Section bg="light">
				<Top color="blue">THANK YOU</Top>
				<h2>Sponsors / Adjudicators</h2>
				<div className="logos">
					{sponsors.map((x, i) => (
						<div className="img-wrap" key={i}>
							<img src={x.img} alt={x.alt} />
						</div>
					))}
				</div>
			</Section>
		</StyledTestimonials>
	);
};

const sponsors = [
	{
		img: '/img/Image 1.png',
		alt: 'york university logo',
	},
	{
		img: '/img/Image 2.png',
		alt: 'vaughan logo',
	},
	{
		img: '/img/Image 3.png',
		alt: 'cedar centre logo',
	},
	{
		img: '/img/Image 4.png',
		alt: 'music monday logo',
	},
	{
		img: '/img/Image 5.png',
		alt: 'mackenzie health logo',
	},
	{
		img: '/img/Image 6.png',
		alt: 'vaughan film festival logo',
	},
];
